import { render, staticRenderFns } from "./NavTabs.vue?vue&type=template&id=4406ae52&scoped=true&"
import script from "./NavTabs.vue?vue&type=script&lang=js&"
export * from "./NavTabs.vue?vue&type=script&lang=js&"
import style0 from "./NavTabs.vue?vue&type=style&index=0&id=4406ae52&lang=less&scoped=true&"
import style1 from "./NavTabs.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4406ae52",
  null
  
)

export default component.exports